import Request from "../model/Request";
import {RestClient} from "../util/RestClient";
import {Config} from "../util/Config";
import Trace from "../entities/Trace";

export module TraceService {
    export async function get(entityId: string): Promise<Trace[]> {
        const url = Config.get("GET_PRODUCT_ORDER_TRACE_URL", {id: entityId});
        const request = new Request(url)
        const response = await RestClient.get(request);
        const data = response.data.map((t: any) => new Trace(
            t.id,
            t.userId,
            t.createdAt,
            t.description,
            t.name,
            t.entityId,
            t.agencyId,
            t.type,
            t.data,
            t.userName,
        ));
        return data;
    }

}